import { type ComponentType } from 'react';
import { getPlatformComponent } from '@direct-frontend/platform-code';

export const DashboardLayout = getPlatformComponent<ComponentType>({
    desktop: import('./DashboardLayout@desktop'),
    mobile: import('./DashboardLayout@mobile'),
});
